const en = {
  datePicker: {
    required: "Enter a date.",
    format: "Enter a date as {{variable}}.",
    minimum: "Enter a date on or after {{variable}}.",
    maximum: "Enter a date on or before {{variable}}.",
  },
  dateRange: {
    incomplete: "Enter both range dates.",
    reversed: "The end date must not be before the start date.",
    maximumDays: "Choose dates no more than {{variable}} days apart.",
  },
  timePicker: {
    placeholder: "hh:mm",
    enter: "Enter: {{variable}}",
    enterInvalid: "invalid time",
    required: "Enter a time.",
    format: "Enter a time, e.g. 8:50",
    minimum: "Enter a time at or after {{variable}}.",
    maximum: "Enter a time at or before {{variable}}.",
    unavailable: "This time does not exist on the selected date.",
  },
  colorPicker: {
    hex: "Hex",
    recommended: "Recommended colors",
    placeholder: "Select color",
    select: "Select color {{variable}}",
  },
  relativeDay: {
    today: "Today",
    tomorrow: "Tomorrow",
  },
  relativeTime: {
    now: "Just now",
    minutes_one: "{{count}} min ago",
    minutes_other: "{{count}} min ago",
    hours_one: "{{count}} h ago",
    hours_other: "{{count}} h ago",
    days_one: "{{count}} day ago",
    days_other: "{{count}} days ago",
  },
  colorPalette: {
    names: {
      blue: "Blue",
      amber: "Amber",
      green: "Green",
      pink: "Pink",
      graphite: "Graphite",
      red: "Red",
      lightGreen: "Light green",
      lightBlue: "Light blue",
      indigo: "Indigo",
      lavender: "Lavender",
      rose: "Rose",
      orange: "Orange",
      mustard: "Mustard",
      turquoise: "Turquoise",
      sky: "Sky blue",
      mint: "Mint",
    },
  },
  emojiPicker: {
    open: "Choose emoji",
  },
  devicePreview: {
    desktop: "Desktop",
    tablet: "Tablet",
    phone: "Phone",
  },
  placeholder: {
    desktopOnlyTitle: "Open on a bigger screen",
    desktopOnlyDescription:
      "This view needs more room than a phone can give.\nOpen it on a tablet or a computer.",
  },
  common: {
    dialog: "Dialog",
    close: "Close",
    rangeMinimum: "{{variable}} minimum",
    rangeMaximum: "{{variable}} maximum",
    selectItem: "Select {{variable}}",
    cancel: "Cancel",
    confirm: "Confirm",
    edit: "Edit",
    save: "Save",
    apply: "Apply",
    continue: "Continue",
    selected: "selected",
    searchPlaceholder: "Search...",
    fileUploadPlaceholder: "Choose a file or drag it here",
    fileUploadAction: "Choose a file",
    fileSizeOf: "of",
    fileUploading: "Uploading...",
    fileUploadRetry: "Try again",
    remove: "Remove",
    range: "Range",
    feature: "Feature",
    periodRange: "Period range",
    more: "More",
    actions: "Actions",
    tags: "Tags",
    filters: "Filters",
    energy: "Energy",
    protein: "Protein",
    fats: "Fats",
    carbs: "Carbohydrates",
    micronutrients: "Micronutrients",
    macronutrients: "Macronutrients",
    show: "Show",
    clearAll: "Clear all",
    createOption: 'Add "{{name}}"',

    noResultLabel: "No results found",
    noResultDescription: "Try adjusting your filters or search criteria",
    clearFilters: "Clear filters",
    selectedCount: "Selected: {{count}}",
    unselect: "Deselect",
    noDataYetTitle: "No data yet",
    noDataYetDescription: "There's nothing here yet.",
    errorPlaceholderTitle: "Something went wrong",
    errorPlaceholderDescription: "An error occurred. Please try again later.",
    noDataAvailable: "No data available",
    noDataAvailablePlaceholder: "There is no data to display at the moment",
    noFutureDataTitle: "No future data",
    noFutureDataDescription:
      "Future data will appear here once it becomes available",
    noAccessDataTitle: "Access limited",
    noAccessDataDescription:
      "You don't have access to this data for the selected period",
    changeDateRange: "Change date range",
    changeProperties: "Change properties",
    futureDescription: "This feature will be available in the future",
    futureAccountDescription:
      "This feature will be available for your account soon",
    ownPropertyDescription: "This is your own property",

    accessLimited: "Access limited",
    accessLimitedForSomeDates: "Access limited for some dates",
    accessLimitedTooltipDescription:
      "You don't have access to data for some dates in this range",
    accessLimitedAvailablePeriods: "Available periods:",

    pageOf: "Page {{current}} of {{total}}",
    rowsPerPage: "Rows per page:",
    pageOfEmphasis: "Page <strong>{{current}}</strong> of {{total}}",
    firstPage: "First page",
    previousPage: "Previous page",
    nextPage: "Next page",
    lastPage: "Last page",
  },
  calendar: {
    noEntries: "No entries in this period",
    releaseToAdd: "{{duration}}, release to add",
    moreEntries: "+{{count}} more",
    noDayEntries: "No entries",
    dayEntries: "Entries this day: {{count}}",
    noEntriesHint: "Click the grid in the day or week view to add an entry.",
    openDay: "Open day view",
    weekdayAbbr: {
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun",
    },
    unassigned: "Other entries",
    previous: "Previous",
    next: "Next",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    previousYear: "Previous year",
    nextYear: "Next year",
    navigation: {
      today: "Today",
      previousPeriod: "Previous period",
      nextPeriod: "Next period",
    },
    shortcuts: {
      today: "T",
      day: "D",
      week: "W",
      month: "M",
      list: "L",
    },
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
    weekDaysMin: {
      monday: "Mo",
      tuesday: "Tu",
      wednesday: "We",
      thursday: "Th",
      friday: "Fr",
      saturday: "Sa",
      sunday: "Su",
    },
    periods: {
      thisMonth: "This month",
      monthToDate: "Month to date",
      yearToDate: "Year to date",
      lastMonth: "Last month",
      lastYear: "Last year",
      monthToEnd: "Month to end",
      yearToEnd: "Year to end",
      thisYear: "This year",
      nextMonth: "Next month",
      next365Days: "Next 365 days",
    },
  },
  sidebar: {
    expandTooltip: "Expand sidebar",
    collapseTooltip: "Collapse sidebar",
    navigation: "Main navigation",
    openNavigation: "Open navigation",
    closeNavigation: "Close navigation",
    search: "Search",
    searchPlaceholder: "Search…",
    soon: "Soon",
    unseen: "New",
  },
  pageSaveBar: {
    unsaved: "You have unsaved changes",
  },
  listPage: {
    search: "Search",
    searchIn: "Search in: {{variable}}",
    closeSearch: "Close search",
    more: "More",
    filters: "Filters",
    columns: "Columns",
    view: "View",
    list: "List",
    grid: "Grid",
    showResults: "Show results",
    showResultsCount: "Show results ({{variable}})",
    resetFilters: "Clear all",
    searchFilters: "Search in filters",
    filterName: "Search in filters",
    clearSection: "Clear “{{variable}}”",
    clear: "Clear",
    searchOptions: "Search",
    noMatchingOptions: "No matching options",
    showAll: "Show all ({{variable}})",
    showLess: "Show less",
    noMatchingFilters: "No matching filters",
    noMatchingFiltersHint: "Check the spelling or clear the search.",
    moreFilters: "More filters ({{variable}})",
    activeFilters: "Active filters:",
    clearAll: "Clear all",
    removeFilter: "Remove the “{{variable}}” filter",
  },
  spotlight: {
    title: "Search",
    placeholder: "Search…",
    recent: "Recently searched",
    clear: "Clear",
    results: "Search results ({{count}})",
    noResults: "No results",
    remove: "Remove “{{name}}” from history",
  },
  theme: {
    switchToDark: "Switch to dark mode",
    switchToLight: "Switch to light mode",
  },
  richTextEditor: {
    unreadable:
      "The saved content could not be read. Editing is locked so the original is not overwritten — please report this.",
    toolbar: "Formatting",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    pageGuides: "PDF pages",
    paragraph: "Normal text",
    heading: "Heading {{level}}",
    quote: "Quote",
    fontSizeDefault: "Default",
    bold: "Bold",
    italic: "Italic",
    underline: "Underline",
    strikethrough: "Strikethrough",
    code: "Code",
    textColor: "Text colour",
    resetColor: "Default colour",
    highlight: "Highlight",
    removeHighlight: "Remove highlight",
    backgroundColor: "Background colour",
    removeBackgroundColor: "Remove background colour",
    table: {
      label: "Table",
      insert: "Insert table",
      addRowBefore: "Add row above",
      addRowAfter: "Add row below",
      deleteRow: "Delete row",
      addColumnBefore: "Add column left",
      addColumnAfter: "Add column right",
      deleteColumn: "Delete column",
      toggleHeaderRow: "Header row",
      mergeOrSplit: "Merge / split cells",
      delete: "Delete table",
    },
    link: "Link",
    linkText: "Text",
    linkUrl: "Address",
    removeLink: "Remove link",
    image: "Image",
    imageFromDisk: "Upload from computer",
    imageError: "This image could not be added.",
    imageUrl: "Image address",
    imageAlt: "Description",
    bulletList: "Bulleted list",
    orderedList: "Numbered list",
    listStyle: "List style",
    listStyles: {
      disc: "Filled circle",
      circle: "Empty circle",
      square: "Square",
      decimal: "1, 2, 3",
      lowerAlpha: "a, b, c",
      upperAlpha: "A, B, C",
      lowerRoman: "i, ii, iii",
      upperRoman: "I, II, III",
    },
    taskList: "Checklist",
    textAlign: "Alignment",
    alignLeft: "Align left",
    alignCenter: "Centre",
    alignRight: "Align right",
    alignJustify: "Justify",
    lineHeight: "Line spacing",
    lineHeightDefault: "Default",
    specialCharacter: "Special character",
    undo: "Undo",
    redo: "Redo",
    divider: "Divider",
    clearFormatting: "Clear formatting",
  },
};

export default en;
